import { graphql } from "react-relay";

export const ResetUserPasswordMutation = graphql`
  mutation ResetUserPasswordMutation($input: ResetUserPasswordInput!) {
    resetUserPassword(input: $input) {
      user {
        key
      }
    }
  }
`;
